import React, { useState, useEffect } from "react";
import useBank from "../hooks/useBank";

const PaymentSuccess = ({}) => {
  const [dataOrderJson, setDataOrderJson] = useState(null);
  const [imageComplete, setImageComplete] = useState("/assets/images/payment/completed.png");
  const { fetchSingleBank, single, status } = useBank();
  const formatTextChoice = (text) => {
    //return useTextFormatter(text);
    if (text === "") {
      return "";
    } else {
      const raw = text.replace(/\n/g, "<br />");

      return raw;
    }
    // const formatted = useMemo(() => {
    // if (!text) return "";

    // }, [text]);

    // return formatted;
  };

  useEffect(() => {
    let dataOrder = localStorage.getItem('checkoutData');
    console.log(dataOrder);
    if (dataOrder !== null) {
      //console.log(JSON.parse(dataOrder))
      setDataOrderJson(JSON.parse(dataOrder));
      fetchSingleBank(JSON.parse(dataOrder)?.bankTransferId);
    }
  }, []);

  useEffect(() => {
    if (status === "done") {
      //console.log(single);
      setImageComplete(single?.image);
    }
    //console.log(single);
  }, [status]);

  return (
    <section className="checkout py-80">
      <div className="container container-lg d-flex flex-column align-items-center justify-content-center text-center">
        <h3 className="text-xl mb-24">Scan to Pay</h3>
        <img src={imageComplete} className="mb-24" alt="" width={200} height={200} />
        {/* <h6 className="text-xl mb-24">Payment Completed</h6> */}
        {/* <p>Payment Success</p> */}
        <span className="mb-24" style={{ maxWidth: "400px", textAlign: "left" }}>
          Open the camera app or the QR app on your phone. Scan the code above and click on the link that will appear. Follow the instructions on your phone to complete your payment. 
        </span>
        <span className="mb-24">
          You can check your order status in your <a href="/account?t=order">account page</a>.
          
        </span>
      </div>
    </section>
  );
};

export default PaymentSuccess;
